<template>
  <div class="teacher-select">
    <el-select
      class="teacher-select__select"
      :class="{ 'is-multiple': multiple }"
      v-model="val"
      filterable
      :multiple="multiple"
      :collapse-tags="multiple"
      remote
      clearable
      :placeholder="placeholder"
      :remote-method="remoteMethod"
      :loading="loading"
      :reserve-keyword="multiple"
      v-bind="$attrs"
      v-on="$listeners"
      @clear="handleClear"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <el-popover
      v-if="multiple && selectedItems.length"
      popper-class="teacher-select__popover"
      placement="top"
      trigger="hover"
    >
      <div class="teacher-select__popover-list">
        <div
          v-for="item in selectedItems"
          :key="item.value"
          class="teacher-select__popover-item"
        >
          <span class="teacher-select__popover-label" :title="item.label">
            {{ item.label }}
          </span>
          <i
            class="el-icon-close teacher-select__popover-remove"
            @click.stop="handleRemoveSelected(item.value)"
          />
        </div>
      </div>
      <i slot="reference" class="el-icon-view teacher-select__eye" />
    </el-popover>
  </div>
</template>

<script>
import { getTeacherList } from '@/api/shop'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    autoload: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请输入IP'
    },
    attribute: {
      type: String,
      default: 'lecturerId'
    },
    config: {
      type: Object,
      default: () => {}
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      loading: false
    }
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
        if (!val || (Array.isArray(val) && !val.length)) return
        if (this.multiple && Array.isArray(val)) {
          const dataList = val
            .map(v => this.options.find(i => i.value === v))
            .filter(Boolean)
          this.$emit('getDetail', dataList)
          return
        }
        const data = this.options.find(i => i.value === val)
        this.$emit('getDetail', data)
      }
    },
    setConfig() {
      return {
        api: getTeacherList,
        nameKey: 'lecturerName',
        label: 'lecturerName',
        value: 'lecturerId',
        ...this.config
      }
    },
    selectedItems() {
      const val = this.value
      if (!this.multiple || !Array.isArray(val) || !val.length) return []
      return val
        .map(v => {
          const hit = this.options.find(i => i.value === v)
          return {
            value: v,
            label: hit?.label || String(v)
          }
        })
        .filter(i => i.value !== undefined && i.value !== null)
    }
  },
  created() {
    if (this.autoload) {
      this.remoteMethod()
    }
  },
  methods: {
    remoteMethod1(params) {
      this.loading = true
      this.setConfig.api(params)
        .then((res) => {
          this.options = res.data.map((v) => {
            return {
              ...v,
              label: v[this.setConfig.label],
              value: v[this.setConfig.value]
            }
          })
          this.loading = false
        })
        .catch(() => {
          this.options = []
          this.loading = false
        })
    },
    remoteMethod(queryString = '') {
      this.loading = true
      const params = {
        [this.setConfig.nameKey]: queryString
      }
      this.setConfig.api(params)
        .then((res) => {
          this.options = res.data.map((v) => {
            return {
              ...v,
              label: v[this.setConfig.label],
              value: v[this.setConfig.value]
            }
          })
          this.loading = false
        })
        .catch(() => {
          this.options = []
          this.loading = false
        })
    },
    handleClear() {
      this.remoteMethod()
    },
    handleRemoveSelected(value) {
      const current = Array.isArray(this.value) ? this.value : []
      const next = current.filter(v => v !== value)
      this.$emit('change', next)
      const dataList = next
        .map(v => this.options.find(i => i.value === v))
        .filter(Boolean)
      this.$emit('getDetail', dataList)
    },
    setDefaultValue(queryString) {
      const params = {
        [this.setConfig.nameKey]: queryString
      }
      this.setConfig.api(params)
        .then((res) => {
          this.options = res.data.map((v) => {
            return {
              ...v,
              label: v[this.setConfig.label],
              value: v[this.setConfig.value]
            }
          })
          this.$emit('change', this.options[0].value)
          this.$emit('getDetail', this.options[0])
        })
        .catch(() => {
          this.options = []
        })
    }
  }
}
</script>

<style>
.teacher-select {
  position: relative;
}

.teacher-select__eye {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
  color: #909399;
}
.teacher-select__select {
  width: 100%;
}
.teacher-select__select.is-multiple ::v-deep .el-input__inner {
  padding-right: 60px;
}

.teacher-select__select.is-multiple ::v-deep .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
  max-width: calc(100% - 60px);
}

.teacher-select__select.is-multiple ::v-deep .el-tag {
  max-width: 100%;
}

.teacher-select__select.is-multiple ::v-deep .el-select__tags-text {
  display: inline-block;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teacher-select__popover {
  max-width: 360px;
}

.teacher-select__popover-list {
  max-height: 240px;
  overflow: auto;
}

.teacher-select__popover-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
}

.teacher-select__popover-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teacher-select__popover-remove {
  cursor: pointer;
}
</style>
